import React from 'react'
import styles from './index.module.scss'
import Layout from '../../components/Layout'
import Content from '../../components/Content'
import GeoProvider from '../../components/GeoProvider'
import DashboardPage from './DashboardPage'
import dataDisplayOptions from './dataDisplayOptions'
import { startDate, endDate, displayDate } from './dates'
import Filter from './filter'
// import Header from './Header'
// import Gender from './GenderAgePanel'
// import SeasonalPattern from '../SeasonalPattern'
import SystemNotification from './../Dashboard/SystemNotification'
const UTIDashboard = () => {
  return (
    <Layout>
      <Content style={{  }}>
        <div className={styles.base}>
          <div className={styles.body}>
            <GeoProvider
              startDate={startDate}
              endDate={endDate}
              displayDate={displayDate}
              mapOptions={dataDisplayOptions[0]['options'][0]}
              indicatorName={dataDisplayOptions[0]['options'][0].indicatorName}
              regionSelected={'metro'}
              getAgeState={{label:'All',value:'0'}}
            >
              <SystemNotification/>
              <Filter/>
              <DashboardPage/>

            </GeoProvider>
          </div>
        </div>
      </Content>
    </Layout>
  )
}

export default UTIDashboard
